import type { TimeIntervalDropDown } from "../../ui/shared/AdvancedDateWidget/types";

import type { WaterlyAppStateCreator } from "./waterlyAppStateCreator.type";

export type CurrentIntervalState = {
  currentInterval?: TimeIntervalDropDown;
  intervals?: TimeIntervalDropDown[];
  intervalsNoDaily?: TimeIntervalDropDown[];
  // when set, DataEntryWrapper will select this interval by id after the next refetch
  pendingSelectIntervalId?: number | null;
};

type CurrentIntervalActions = {
  setCurrentInterval: (interval: TimeIntervalDropDown) => void;
  setIntervals: (intervals: TimeIntervalDropDown[]) => void;
  resetCurrentInterval: () => void;
  setIntervalById: (intervalId: number) => void;
  setPendingSelectIntervalId: (intervalId: number | null) => void;
};

const initialState: CurrentIntervalState = {
  currentInterval: undefined,
  intervals: undefined,
  pendingSelectIntervalId: null,
};

export const createCurrentIntervalSlice: WaterlyAppStateCreator<
  CurrentIntervalActions,
  CurrentIntervalState
> = (set, getCurrentState) => ({
  ...initialState,
  setCurrentInterval: (interval) => {
    // If this is the same interval, no need to update it.
    if (interval.id === getCurrentState().currentInterval?.id) {
      return;
    }
    set(
      {
        currentInterval: interval,
      },
      undefined,
      "currentInterval:setCurrentInterval",
    );
  },
  setIntervals: (intervals) => {
    set(
      {
        intervals,
        intervalsNoDaily: intervals.filter((interval) => interval.id !== -1),
      },
      undefined,
      "currentInterval:setIntervals",
    );
  },
  resetCurrentInterval() {
    set(
      {
        currentInterval: undefined,
      },
      undefined,
      "currentInterval:resetCurrentInterval",
    );
  },
  setPendingSelectIntervalId: (intervalId: number | null) => {
    set({ pendingSelectIntervalId: intervalId }, undefined, "currentInterval:setPendingSelectIntervalId");
  },
  setIntervalById: (intervalId: number) => {
    set(
      (state) => {
        const interval = state.intervals?.find((interval) => interval.id === intervalId);
        if (interval) {
          return { currentInterval: interval };
        }
        return {};
      },
      undefined,
      "currentInterval:setIntervalById",
    );
  },
});
